<template>
    <div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="名称">
            </el-table-column>
            <el-table-column prop="price" label="单价">
                <template slot-scope="scope">
                    <!-- <el-button  type="text" @click="setRow(scope.row)">修改</el-button> -->
                    <el-input @input="(v) => (scope.row.price = v.replace(/[^\d.]/g, ''))" v-model="scope.row.price"
                        placeholder="请输入单价"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位">
            </el-table-column>
            <el-table-column prop="address" label="更新日期">
            </el-table-column>
        </el-table>

        <div style="width:50px;margin-top:20px;margin-left:25%;">
            <el-button type="primary" @click="submitTab">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [
                {
                    name: "公寓-电费",
                    price: 0,
                    unit: "元/度",
                    updateDate: ""
                },
                {
                    name: "公寓-水费",
                    price: 0,
                    unit: "元/m3",
                    updateDate: ""
                },
                {
                    name: "公寓-物业费",
                    price: 0,
                    unit: "元/m2",
                    updateDate: ""
                },
            ]
        }
    },
    created() {
        this.get();
    },
    methods: {
        submitTab() {
            let status = true;
            this.tableData.forEach(element => {
                if (element.price === "") {
                    status = false
                }
            });
            if (!status) {
                this.$message.error("单价不能为空！");
                return;
            }
            console.log(this.tableData)
        },
        get() {
            // system/config/list?pageNum=1&pageSize=10&configName=&configKey

            this.$http.get("/api/system/config/list?pageNum=1&pageSize=10&configKey=apartment.electricity", {}).then(res => {
                console.log(res)


            })

        }
    }
}
</script>

<style>

</style>
